import { useMemo } from 'react';
import { useAccessControl } from '../contexts/AccessControlContext';
import type { AccessRequirement, PermissionCode, RoleCode } from './types';
import { hasPermission as hasPermissionImpl } from './permissionUtils';

export function useRole(): { roleCode: RoleCode; roleName: string; roleId: number } {
  const ac = useAccessControl();
  return {
    roleCode: ac.snapshot?.roleCode ?? 'UNKNOWN',
    roleName: ac.snapshot?.roleName ?? '',
    roleId: ac.snapshot?.roleId ?? 0,
  };
}

export function usePermission() {
  const ac = useAccessControl();
  return useMemo(
    () => ({
      loading: ac.loading,
      has: (code: PermissionCode) => hasPermissionImpl(ac.permissions, code),
      canAccess: (req?: AccessRequirement) => ac.canAccess(req),
      permissions: ac.permissions,
    }),
    [ac],
  );
}

